<template>
    <div>
        <Button
            v-if="!$route.path.includes('new')" 
            @click="$router.go(-1)" 
            class="mb-4" 
            size="small"
            type="outline" 
            color="grey"
        >
            <ArrowDropdown :rotate="90" class="mr-2" :color="`#727D94`"/>
            Voltar
        </Button>
        <div class="row d-flex mb-4 justify-content-end">
            <div class="col-8">
                <h3 class="c-ndarkthree">
                    <span class="bold">{{ partnerTitle }}</span> |  Cadastrar financiadores
                </h3>
            </div>
            <el-dropdown trigger="click" class="col-4 pb-2 d-flex justify-content-end">
                <Button :color="getPrimaryColor" class="pl-4 pr-4">
                    <span>Novo financiador</span>
                    <ArrowDropdown class="ml-3" color="white" rotate="360"/>
                </Button>
                <el-dropdown-menu slot="dropdown">
                    <ActionBtnItemsContainer :withoutBottomLine="false">
                        <el-dropdown-item>
                            <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center" @click="newSponsor()">
                                <svg class="mr-2" width="15" height="15" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.99983 1V9M1 5H8.99967" stroke="#A1A8B8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Cadastrar um financiador
                            </span>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <el-upload
                            action="not"
                            :auto-upload="false"
                            :limit="3"
                            :show-file-list="false"
                            :on-change="handleFileChange"
                            :file-list="fileList"
                            accept=".xls,.xlsx"
                            >
                                <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                    <Upload size="15" color="#A1A8B8" class="mr-2" />
                                    Cadastrar financiadores em lote
                                </span>
                            </el-upload>
                        </el-dropdown-item>
                    </ActionBtnItemsContainer>
                    <ActionBtnItemsContainer :withoutBottomLine="true">
                        <el-dropdown-item @click.native="handleSpreadsheetDownload">
                            <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                <Download size="15" color="#A1A8B8" class="mr-2" />
                                Baixar modelo de planilha
                            </span>
                        </el-dropdown-item>
                    </ActionBtnItemsContainer>
                </el-dropdown-menu>
            </el-dropdown>
            <div class="col-12 mt-4 pt-3 d-flex align-items-center justify-content-end">
                <div class="ml-2">
                    <el-input  @keyup.native.enter="filterSponsors" placeholder="Buscar" v-model="filter"  :class="`${getPrimaryColor} filter`" clearable>
                        <button class="btn" slot="append" @click="filterSponsors">
                            <SearchIcon class="mx-0" size="16" />
                        </button>
                    </el-input>
                    <h6 slot="append" class="regular">
                        Busque pelo nome do financiador. Ex.: <span :class="`c-${getPrimaryColor}four`"> Uni Impacta. </span>
                    </h6>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <TableLoading v-if="isLoading" rowHeight="56" class="mt-3"/>
                <ManageSponsorPartner v-else-if="sponsors.length" :tableData="sponsors" @buyerDeleted="getGroup"/>
                <NotFound v-else-if="notFound"/>
                <Empty
                    title="Nenhum financiador associado!"
                    v-else
                >
                    Por enquanto, não há financiadores associados.
                </Empty>
            </div>
        </div>
        <PartnerCard v-if="$route.path.includes('new')" @newMainRules="newMainRules" @toGoBack="toGoBack"/>
        <ProcessingSponsors
            company="buyer"
            :dialogVisible="dialogVisible"
            @closeModal="closeModal"
        />
    </div>
</template>

<script>
//ICONS
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import Download from '@/components/icons/Download'
import Upload from '@/components/icons/Upload'

//COMPONENTS
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer.vue'
import TableLoading from '@/components/loading/TableLoading'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import ManageSponsorPartner from '@/components/tables/ManageSponsorPartner.vue'
import PartnerCard from '@/components/cards/PartnerCard.vue'
import ProcessingSponsors from '@/components/modals/ProcessingSponsors'

//API
import importSponsorPartner from '@/api/importSponsorPartner'
import downloadArchive from '@/api/downloadArchive'
import getSponsorsByPartnerId from '@/api/getSponsorsByPartnerId'
import getCompany from '@/api/getCompany'
import Empty from '@/components/emptyOrNotFound/EmptyEconomicGroup'
import getSponsorByName from "@/api/getSponsorByName"

//UTILS
import { capitalize } from "lodash"

export default {
    components: {
        ArrowDropdown,
        Download,
        Upload,
        ActionBtnItemsContainer,
        TableLoading,
        NotFound,
        ManageSponsorPartner,
        PartnerCard,
        Empty,
        ProcessingSponsors,
    },
    data() {
        return {
            partner: '',
            isLoading: false,
            sponsors: [],
            dialogVisible: false,
            filter: '',
        }
    },
    watch: {
        filter(val) {
            if (!val.length) {
                this.getSponsors()
            }
        }
    },
    computed: {
        partnerTitle() {
            const newPartner = this.$route.path.includes('new')
            if(newPartner) return 'Novo parceiro'
            return this.partner
        }
    },
    methods: {
        async getSponsors() {
            this.isLoading = true

            const result = await getSponsorsByPartnerId(this.$route.params.partnerId)
            this.partner = capitalize(result[0].name)
            this.sponsors = result[0].sponsors

            this.isLoading = false
        },
        async filterSponsors() {
            this.isLoading = true

            let filteredSponsor = await getSponsorByName(this.filter)
            filteredSponsor = filteredSponsor[0] ? filteredSponsor[0] : null
            const result = await getSponsorsByPartnerId(this.$route.params.partnerId, filteredSponsor)
            if(result[0].sponsors.length) {
                this.notFound = false
                this.sponsors = result[0].sponsors
            } else {
                this.notFound = true
                this.sponsors = []
            }

            this.isLoading = false
        },
        newSponsor() {
            this.$router.push(`/partner/${this.$route.params.partnerId}/company/new/0`)
        },
        async newMainRules() {
            const mainSponsor = this.sponsors.find(s => s.sponsorPartners.main)

            if (mainSponsor) await getCompany({ cnpjId: mainSponsor.cnpjId, companyType: '0'})

            this.$router.push(`/partners/new/${this.$route.params.partnerId}/sponsor/${mainSponsor.cnpjId}/rules`)
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleFileChange(file) {
           this.loadingText = 'Importando financiadores...'
           const base64File = await this.toBase64(file.raw)
           const base64Header = base64File.indexOf(',') + 1
           const fileData = {
               partner: [ parseInt(this.$route.params.partnerId) ],
               sponsorFile: base64File.slice(base64Header , base64File.length)
           }
           const result = await importSponsorPartner(fileData)
           if (result.data.ok) {
               this.dialogVisible = true
           }
           this.loadingText = 'Carregando...'
        },
        handleSpreadsheetDownload() {
            downloadArchive(`https://v3.cashforce.com.br/clients/assets/templates/template_cnpj_financiadores.xlsx`, '', {})
        },
        closeModal() {
            this.fileList = []

            window.location.reload()

            this.dialogVisible = false
        },
        toGoBack() {
            const newPartner = this.$route.path.includes('new')
            if(newPartner) return this.$router.push(`/partners/${this.$route.params.partnerId}/update`)
            return this.$router.go(-1)
        }
    },
    created () {
        this.getSponsors()
    }
}

</script>